// extracted by mini-css-extract-plugin
export var emailBlockLink = "_pb-0";